import { Accordion, AccordionItem, AccordionTrigger } from "@sorcery/ui";
import { useState } from "react";
import type { CardType, VariantType } from "~/types/card";
import { DeckHistorySection } from "./DeckHistorySection";

type Props = {
  onCardHover?: (squiggle: { card: CardType; variant: VariantType }) => void;
};

export const DeckHistory = ({ onCardHover }: Props) => {
  const [opened, setOpened] = useState(false);

  return (
    <Accordion
      type="single"
      collapsible={true}
      className="animate-in fade-in"
      onValueChange={() => {
        setOpened(true);
      }}
    >
      <AccordionItem
        value={"Deck History"}
        className="border-t border-t-line-color animate-in fade-in"
      >
        <AccordionTrigger className="pr-1 font-normal">Deck History</AccordionTrigger>

        <DeckHistorySection onCardHover={onCardHover} opened={opened} />
      </AccordionItem>
    </Accordion>
  );
};
